import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CheckSmall } from 'shared-components/icons';

const RadioButtonWithSubLabel = ({
  input = {},
  className = null,
  displayTitle = '',
  displayText = '',
  currentlySelected,
  addtionalClasses = ''
}) => {
  const labelClassNames = `btn btn-default btn-block text-left ${addtionalClasses}`;
  return (
    <div className={classNames('radio-button-hidden margin-lg-top', className)}>
      <input
        className=""
        id={input.id}
        type="radio"
        name={input.name}
        value={input.value}
        onChange={input.onChange}
      />
      <label htmlFor={input.id} className={labelClassNames} style={{ paddingTop: '12px', paddingBottom: '12px' }}>
        <div className="flex space-between">
          <div className="text-left">
            <div>
              <h5 className={`margin-no-bottom margin-no-top ${!currentlySelected ? 'text-gray-dark' : ''}`}>
                {displayTitle}
              </h5>
            </div>
            {currentlySelected && <div className="sub-label">{displayText}</div>}
          </div>
          {currentlySelected && <div className="checkmark flex middle"><CheckSmall /></div>}
        </div>
      </label>
    </div>
  );
};

RadioButtonWithSubLabel.propTypes = {
  input: PropTypes.object,
  className: PropTypes.string,
  displayText: PropTypes.object,
  displayTitle: PropTypes.object,
  currentlySelected: PropTypes.bool,
  addtionalClasses: PropTypes.string

};

export default RadioButtonWithSubLabel;
